const imageServiceDomain = 'https://img2.storyblok.com';

const scales = [1, 2, 3.5, 4.5];

const getCrop = ({ width, height }, isSmart) =>
  `/${width}x${height}${isSmart ? '/smart' : ''}`;

const getFocus = (focus) => (focus ? `:focal(${focus})` : '');

const getFormat = (format) => `:format(${format})`;

const getQuality = (quality) => `:quality(${quality})`;

const getBlur = (blur) => (blur ? `:blur(${blur})` : '');

const getResourcePath = ({ filename }) =>
  filename.replace('https://a.storyblok.com', '');

const getSizeFromSizeStr = (sizeStr) => {
  const sizes = sizeStr.split('x');

  const width = Number(sizes[0]);
  const height = Number(sizes[1]);

  return {
    aspectRatio: width / height,
    width,
    height,
  };
};

const getSizes = (image, minSize) => {
  const imageResourcePath = getResourcePath(image);
  const imageSize = getSizeFromSizeStr(minSize);

  const computedScales = scales.map((scale, i) => {
    const dimensions = {
      width: Math.round(imageSize.width * scale),
      height: Math.round(imageSize.height * scale),
    };

    return {
      dimensions,
      image,
      resourcePath: imageResourcePath,
      sizing: `${dimensions.width}w`,
    };
  });

  return computedScales;
};

const generateImageSrc = (
  { dimensions, image, resourcePath },
  format,
  quality,
  blur
) =>
  `${imageServiceDomain}${getCrop(
    dimensions,
    !Boolean(image.focus)
  )}/filters${getBlur(blur)}${getFocus(image.focus)}${getFormat(
    format
  )}${getQuality(quality)}${resourcePath}`;

const generateSources = (sizes, format, quality) => {
  const srcSet = sizes
    .map((size) => {
      return generateImageSrc(size, format, quality) + ` ${size.sizing}`;
    })
    .join(', ');

  const src = generateImageSrc(sizes[sizes.length - 1], format, quality);

  return {
    src,
    srcSet,
  };
};

export const getPlaceholderImageSrc = (image) => {
  if (!image || !image.filename) {
    return '';
  }

  const imageResourcePath = getResourcePath(image);

  return generateImageSrc(
    {
      dimensions: {
        width: 0,
        height: 40,
      },
      image,
      resourcePath: imageResourcePath,
    },
    'png',
    70,
    3
  );
};

export const createCleanUrl = (src) =>
  `url(${src.replace(/\(/g, '\\(').replace(/\)/g, '\\)')})`;

export const getFluidProps = (image, minSize, quality) => {
  if (!image || !image.filename) {
    return;
  }

  const imageResourcePath = getResourcePath(image);

  const { aspectRatio: originalAspectRatio } = getSizeFromSizeStr(
    imageResourcePath.split('/')[3]
  );
  const {
    aspectRatio: minSizeAspectRatio,
    height: minHeight,
    width: minWidth,
  } = getSizeFromSizeStr(minSize);

  const aspectRatio =
    minHeight === 0 || minWidth === 0
      ? originalAspectRatio
      : minSizeAspectRatio;

  const computedSizes = getSizes(image, minSize);

  const { src, srcSet } = generateSources(computedSizes, 'png', quality);

  const { src: srcWebp, srcSet: srcSetWebp } = generateSources(
    computedSizes,
    'webp',
    quality
  );

  return {
    aspectRatio,
    src,
    srcSet,
    sizes: '100vw',
    srcWebp,
    srcSetWebp,
  };
};
